export default "__VITE_ASSET__illCQ2lq__"